import axios from 'axios';

const solicitar = (idCotacao, idResposta, negociacao) => axios.post(`/cotacoes/${idCotacao}/respostas/${idResposta}/negociacoes/solicitar`, negociacao);
const getNegociacoes = (idCotacao, idResposta) => axios.get(`/cotacoes/${idCotacao}/respostas/${idResposta}/negociacoes`);

export default {
  solicitar,
  getNegociacoes,
};
